import {
  AnalyzeSitewideFrontendTinybirdRequestBodyType,
  DatasetId,
} from "@intelligems/ig-types";
import { useBuildSitewideAnalyticsPayload } from "@src/api/analytics/hooks/use-build-sitewide-analytics-payload";
import { api } from "@src/api/api";
import { sitewideAnalyticsKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

const fetchSitewideAnalytics = async (
  data: AnalyzeSitewideFrontendTinybirdRequestBodyType
) => {
  const resp = await api.post<any, any>(
    `/v2/analytics/sitewide-analysis`,
    data
  );
  return resp.data;
};

export const useGetSitewideAnalytics = (datasetId: DatasetId) => {
  const buildSitewidePayload = useBuildSitewideAnalyticsPayload();
  const data = buildSitewidePayload.build(datasetId);

  return useQuery<any>({
    queryKey: [sitewideAnalyticsKeys.all(data)],
    queryFn: async () => fetchSitewideAnalytics(data),
  });
};
